import { Component, Input, OnInit } from '@angular/core';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { PageModel } from 'app/models/page-model';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';

interface PaymentProviderModel {
  id: number;
  locationId: number;
  paymentUuid: string;
  reservationUuids: string[];
  total: number;
  provider: string;
  phases: string[];
  currentPhase: string;
  event: unknown;
  status: string;
  createdAt: string;
  updatedAt: string;
  paymentIntent: string | null;
  subscriptionId: string | null;
  invoiceId: string | null;
  subscriptionPeriodStart: string | null;
  stripeSubscriptionPeriodEnd: string | null;
}

@Component({
  selector: 'app-admin-payment-provider-page',
  templateUrl: './admin-payment-provider.page.html',
  styleUrls: ['./admin-payment-provider.page.scss']
})
export class PaymentProviderPage implements OnInit {
  loading = false;
  paymentProviders: PaymentProviderModel[] = [];
  paymentProvidersPage: PageModel<PaymentProviderModel> = {
    content: [],
    pageNumber: 0,
    pageSize: 10,
    totalPages: 0,
    totalElements: 0,
    first: true,
    last: true
  };
  totalElements = 0;
  pageSize = 10;
  pageIndex = 0;
  displayedColumns: string[] = ['status', 'provider', 'phases', 'currentPhase', 'paymentUuid', 'updatedAt'];

  constructor(private restService: RestService,
    public appService: AppService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.getPaymentProvider();
  }

  setOpen(paymentProvider: PaymentProviderModel){
    this.dialog.open(AdminPaymentProviderDetails, {
      panelClass: 'responsive-dialog',
      maxWidth: '95vw',
      data: { paymentProvider }
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getPaymentProvider();
  }

  getPaymentProvider(page: number = this.pageIndex, size: number = this.pageSize){
    this.loading = true;
    this.restService.getPaymentProviders(page, size).subscribe(result => {
      console.log('getPaymentProviders', result);
      this.paymentProvidersPage = result;
      this.paymentProviders = result.content;
      this.totalElements = result.totalElements;
      this.pageSize = result.pageSize;
      this.pageIndex = result.pageNumber;
      this.loading = false;
    }, () => {
      this.paymentProviders = [];
      this.totalElements = 0;
      this.loading = false;
    });
  }

}



@Component({
  selector: 'app-admin-payment-provider-details',
  templateUrl: './admin-payment-provider-details.component.html',
  styleUrls: ['./admin-payment-provider.page.scss']
})
export class AdminPaymentProviderDetails {


  paymentProvider: PaymentProviderModel;

  constructor(public activeModal: MatDialogRef<AdminPaymentProviderDetails>,
              @Inject(MAT_DIALOG_DATA) public data: { paymentProvider: any },
              private restService: RestService,
              public appService: AppService) {
                this.paymentProvider = data?.paymentProvider;
              }

             
 
  cancel() {
      this.activeModal.close();
  }

  valueOrDash(value: unknown): string {
    if (value === null || value === undefined || value === '') {
      return '—';
    }

    return String(value);
  }

  formatCurrency(value: unknown): string {
    const amount = Number(value);
    if (Number.isNaN(amount)) {
      return '—';
    }

    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  }

  formatDateTime(value: unknown): string {
    if (!value) {
      return '—';
    }

    const date = new Date(String(value));
    if (Number.isNaN(date.getTime())) {
      return String(value);
    }

    return date.toLocaleString('es-ES');
  }

  formatPhaseLabel(value: unknown): string {
    return this.formatEnumLabel(value);
  }

  formatStatusLabel(value: unknown): string {
    return this.formatEnumLabel(value);
  }

  statusClass(status: unknown): string {
    switch (String(status || '').toUpperCase()) {
      case 'RUNNING':
      case 'CAPTURE':
      case 'SUCCESS':
        return 'pp-chip--success';
      case 'PAYMENT_FAILED':
      case 'FAILED':
      case 'ERROR':
        return 'pp-chip--danger';
      case 'REFUND':
      case 'PENDING':
        return 'pp-chip--warning';
      default:
        return 'pp-chip--neutral';
    }
  }

  formatJson(value: unknown): string {
    if (value === null || value === undefined || value === '') {
      return 'Sin payload';
    }

    if (typeof value === 'string') {
      try {
        return JSON.stringify(JSON.parse(value), null, 2);
      } catch {
        return value;
      }
    }

    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return String(value);
    }
  }

  hasEventContent(): boolean {
    return this.formatJson(this.paymentProvider?.event) !== 'Sin payload';
  }

  private formatEnumLabel(value: unknown): string {
    if (value === null || value === undefined || value === '') {
      return '—';
    }

    return String(value)
      .split('_')
      .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join(' ');
  }

}
